module.exports = __webpack_public_path__ + "img/MDC_Longlife_gross.b5c3cc14.png";